import { api } from '../rtk';
import { ENDPOINTS } from '../url';
import { DashboardResponse, DashboardGraphResponse, RevenueGraphResponse } from '../../types/dashboard.types';

export const featuresApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // Skeleton for Features API
        getFeaturesPlaceholder: builder.query({
            query: () => ({
                url: 'placeholder',
                method: 'GET',
            }),
        }),
        getCategories: builder.query({
            query: ({ search, page, limit = 10, type, brandId }) => ({
                url: ENDPOINTS.CATEGORIES,
                method: 'GET',
                params: { search, page, limit, type, brandId },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Categories'],
        }),
        addCategory: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.CATEGORIES,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Categories'],
        }),
        updateCategory: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.CATEGORIES}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Categories'],
        }),
        deleteCategory: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.CATEGORIES}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Categories'],
        }),
        getCategoryDetails: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.CATEGORIES}/${id}`,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Categories'],
        }),
        getBrands: builder.query({
            query: ({ search, page, limit = 10, type }) => ({
                url: ENDPOINTS.BRANDS,
                method: 'GET',
                params: { search, page, limit, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Brands'],
        }),
        addBrand: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.BRANDS,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Brands'],
        }),
        updateBrand: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.BRANDS}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Brands'],
        }),
        deleteBrand: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.BRANDS}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Brands'],
        }),
        getBrandDetails: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.BRANDS}/${id}`,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Brands'],
        }),
        getModels: builder.query({
            query: ({ search, page, limit = 10, brandId, categoryId, type }) => ({
                url: ENDPOINTS.MODELS,
                method: 'GET',
                params: { search, page, limit, brandId, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Models'],
        }),
        addModel: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.MODELS,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Models'],
        }),
        updateModel: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.MODELS}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Models'],
        }),
        deleteModel: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.MODELS}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Models'],
        }),
        getVehicleTypes: builder.query({
            query: ({ search, page, limit = 10, categoryId, type }) => ({
                url: ENDPOINTS.VEHICLE_TYPES,
                method: 'GET',
                params: { search, page, limit, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['VehicleTypes'],
        }),
        addVehicleType: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.VEHICLE_TYPES,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['VehicleTypes'],
        }),
        updateVehicleType: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.VEHICLE_TYPES}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['VehicleTypes'],
        }),
        deleteVehicleType: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.VEHICLE_TYPES}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['VehicleTypes'],
        }),
        getFuelTypes: builder.query({
            query: ({ search, page, limit = 10, categoryId, type }) => ({
                url: ENDPOINTS.FUEL_TYPES,
                method: 'GET',
                params: { search, page, limit, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['FuelTypes'],
        }),
        addFuelType: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.FUEL_TYPES,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['FuelTypes'],
        }),
        updateFuelType: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.FUEL_TYPES}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['FuelTypes'],
        }),
        deleteFuelType: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.FUEL_TYPES}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['FuelTypes'],
        }),
        getEnginePower: builder.query({
            query: ({ search, page, limit = 10, categoryId, type }) => ({
                url: ENDPOINTS.ENGINE_POWER,
                method: 'GET',
                params: { search, page, limit, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['EnginePower'],
        }),
        addEnginePower: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.ENGINE_POWER,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['EnginePower'],
        }),
        updateEnginePower: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.ENGINE_POWER}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['EnginePower'],
        }),
        deleteEnginePower: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.ENGINE_POWER}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['EnginePower'],
        }),
        getTransmission: builder.query({
            query: ({ search, page, limit = 10, categoryId, type }) => ({
                url: ENDPOINTS.TRANSMISSION,
                method: 'GET',
                params: { search, page, limit, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Transmission'],
        }),
        addTransmission: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.TRANSMISSION,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Transmission'],
        }),
        updateTransmission: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.TRANSMISSION}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Transmission'],
        }),
        deleteTransmission: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.TRANSMISSION}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Transmission'],
        }),
        uploadMedia: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.UPLOAD_MEDIA,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
        }),
        getDriveTypes: builder.query({
            query: ({ search, page, limit = 10, categoryId, type }) => ({
                url: ENDPOINTS.DRIVE_TYPE,
                method: 'GET',
                params: { search, page, limit, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['DriveTypes'],
        }),
        addDriveType: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.DRIVE_TYPE,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['DriveTypes'],
        }),
        updateDriveType: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.DRIVE_TYPE}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['DriveTypes'],
        }),
        deleteDriveType: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.DRIVE_TYPE}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['DriveTypes'],
        }),
        getEmissionClass: builder.query({
            query: ({ search, page, limit = 10, categoryId, type }) => ({
                url: ENDPOINTS.EMISSION_CLASS,
                method: 'GET',
                params: { search, page, limit, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['EmissionClass'],
        }),
        addEmissionClass: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.EMISSION_CLASS,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['EmissionClass'],
        }),
        updateEmissionClass: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.EMISSION_CLASS}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['EmissionClass'],
        }),
        deleteEmissionClass: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.EMISSION_CLASS}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['EmissionClass'],
        }),
        getEnvironmentalBadge: builder.query({
            query: ({ search, page, limit = 10, categoryId, type }) => ({
                url: ENDPOINTS.ENVIRONMENTAL_BADGE,
                method: 'GET',
                params: { search, page, limit, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['EnvironmentalBadge'],
        }),
        addEnvironmentalBadge: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.ENVIRONMENTAL_BADGE,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['EnvironmentalBadge'],
        }),
        updateEnvironmentalBadge: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.ENVIRONMENTAL_BADGE}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['EnvironmentalBadge'],
        }),
        deleteEnvironmentalBadge: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.ENVIRONMENTAL_BADGE}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['EnvironmentalBadge'],
        }),
        getDamageType: builder.query({
            query: ({ search, page, limit = 10, categoryId, type }) => ({
                url: ENDPOINTS.DAMAGE_TYPE,
                method: 'GET',
                params: { search, page, limit, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['DamageType'],
        }),
        addDamageType: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.DAMAGE_TYPE,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['DamageType'],
        }),
        updateDamageType: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.DAMAGE_TYPE}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['DamageType'],
        }),
        deleteDamageType: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.DAMAGE_TYPE}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['DamageType'],
        }),
        getAxles: builder.query({
            query: ({ search, page, limit = 10, categoryId, type }) => ({
                url: ENDPOINTS.AXLES,
                method: 'GET',
                params: { search, page, limit, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Axles'],
        }),
        addAxles: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.AXLES,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Axles'],
        }),
        updateAxles: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.AXLES}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Axles'],
        }),
        deleteAxles: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.AXLES}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Axles'],
        }),
        getFeatureGroups: builder.query({
            query: ({ search, page, limit = 10, categoryId, groupType, parentFeatureId, type }) => ({
                url: ENDPOINTS.FEATURES,
                method: 'GET',
                params: { search, page, limit, categoryId, groupType, parentFeatureId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Features'],
        }),
        getFeatureGroupDetails: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.FEATURES}/${id}`,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Features'],
        }),
        addFeatureGroup: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.FEATURES,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Features'],
        }),
        updateFeatureGroup: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.FEATURES}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Features'],
        }),
        deleteFeatureGroup: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.FEATURES}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Features'],
        }),
        getColors: builder.query({
            query: ({ search, page, limit = 10, categoryId, type, groupType }) => ({
                url: ENDPOINTS.COLORS,
                method: 'GET',
                params: { search, page, limit, categoryId, type, groupType },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Colors'],
        }),
        addColor: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.COLORS,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Colors'],
        }),
        updateColor: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.COLORS}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Colors'],
        }),
        deleteColor: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.COLORS}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Colors'],
        }),
        getConditions: builder.query({
            query: ({ search, page, limit = 10, categoryId, type }) => ({
                url: ENDPOINTS.CONDITIONS,
                method: 'GET',
                params: { search, page, limit, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Conditions'],
        }),
        addCondition: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.CONDITIONS,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Conditions'],
        }),
        updateCondition: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.CONDITIONS}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Conditions'],
        }),
        deleteCondition: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.CONDITIONS}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Conditions'],
        }),
        addVehicle: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.CARS,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Vehicles'],
        }),
        getVehicles: builder.query({
            query: ({ search, page, limit = 10, type }) => ({
                url: ENDPOINTS.CARS,
                method: 'GET',
                params: { search, page, limit, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Vehicles'],
        }),
        updateVehicle: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.CARS}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Vehicles'],
        }),
        getVehicleDetail: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.CARS}/${id}`,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Vehicles'],
        }),
        // Variants
        getVariants: builder.query({
            query: ({ search, page, limit = 10, brandId, modelId, categoryId, type }) => ({
                url: ENDPOINTS.VARIANTS,
                method: 'GET',
                params: { search, page, limit, brandId, modelId, categoryId, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Variants'],
        }),
        getVariantDetails: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.VARIANTS}/${id}`,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Variants'],
        }),
        addVariant: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.VARIANTS,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Variants'],
        }),
        updateVariant: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.VARIANTS}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Variants'],
        }),
        deleteVariant: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.VARIANTS}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Variants'],
        }),
        deleteVehicle: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.CARS}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Vehicles'],
        }),
    }),
    overrideExisting: false,
});

const featuresApiWithSpareParts = featuresApi.injectEndpoints({
    endpoints: (builder) => ({
        addSparePart: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.SPARE_PARTS,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['SpareParts'],
        }),
        updateSparePart: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.SPARE_PARTS}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['SpareParts'],
        }),
        deleteSparePart: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.SPARE_PARTS}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['SpareParts'],
        }),
        getSparePartDetails: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.SPARE_PARTS}/${id}`,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['SpareParts'],
        }),
        getSpareParts: builder.query({
            query: ({ search, page, limit = 10, type }) => ({
                url: ENDPOINTS.SPARE_PARTS,
                method: 'GET',
                params: { search, page, limit, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['SpareParts'],
        }),
    }),
    overrideExisting: false,
});

export const {
    useAddSparePartMutation,
    useUpdateSparePartMutation,
    useDeleteSparePartMutation,
    useGetSparePartDetailsQuery,
    useGetSparePartsQuery
} = featuresApiWithSpareParts;

export const {
    useGetFeaturesPlaceholderQuery,
    useGetCategoriesQuery,
    useAddCategoryMutation,
    useUpdateCategoryMutation,
    useDeleteCategoryMutation,
    useGetCategoryDetailsQuery,
    useUploadMediaMutation,
    useGetBrandsQuery,
    useAddBrandMutation,
    useUpdateBrandMutation,
    useDeleteBrandMutation,
    useGetBrandDetailsQuery,
    useGetModelsQuery,
    useAddModelMutation,
    useUpdateModelMutation,
    useDeleteModelMutation,
    useGetVehicleTypesQuery,
    useAddVehicleTypeMutation,
    useUpdateVehicleTypeMutation,
    useDeleteVehicleTypeMutation,
    useGetFuelTypesQuery,
    useAddFuelTypeMutation,
    useUpdateFuelTypeMutation,
    useDeleteFuelTypeMutation,
    useGetEnginePowerQuery,
    useAddEnginePowerMutation,
    useUpdateEnginePowerMutation,
    useDeleteEnginePowerMutation,
    useGetTransmissionQuery,
    useAddTransmissionMutation,
    useUpdateTransmissionMutation,
    useDeleteTransmissionMutation,
    useGetDriveTypesQuery,
    useAddDriveTypeMutation,
    useUpdateDriveTypeMutation,
    useDeleteDriveTypeMutation,
    useGetEmissionClassQuery,
    useAddEmissionClassMutation,
    useUpdateEmissionClassMutation,
    useDeleteEmissionClassMutation,
    useGetEnvironmentalBadgeQuery,
    useAddEnvironmentalBadgeMutation,
    useUpdateEnvironmentalBadgeMutation,
    useDeleteEnvironmentalBadgeMutation,
    useGetDamageTypeQuery,
    useAddDamageTypeMutation,
    useUpdateDamageTypeMutation,
    useDeleteDamageTypeMutation,
    useGetAxlesQuery,
    useAddAxlesMutation,
    useUpdateAxlesMutation,
    useDeleteAxlesMutation,
    useGetFeatureGroupsQuery,
    useGetFeatureGroupDetailsQuery,
    useAddFeatureGroupMutation,
    useUpdateFeatureGroupMutation,
    useDeleteFeatureGroupMutation,
    useGetColorsQuery,
    useAddColorMutation,
    useUpdateColorMutation,
    useDeleteColorMutation,
    useGetConditionsQuery,
    useAddConditionMutation,
    useUpdateConditionMutation,
    useDeleteConditionMutation,
    useAddVehicleMutation,
    useGetVehiclesQuery,
    useUpdateVehicleMutation,
    useDeleteVehicleMutation,
    useGetVehicleDetailQuery,
    // Variants
    useGetVariantsQuery,
    useGetVariantDetailsQuery,
    useAddVariantMutation,
    useUpdateVariantMutation,
    useDeleteVariantMutation,
} = featuresApi;

const featuresApiWithUsers = featuresApi.injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: ({ search, page, limit = 10 }) => ({
                url: ENDPOINTS.MANAGE_USERS,
                method: 'GET',
                params: { search, page, limit, role: 3 },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['ManageUsers'],
        }),
        deleteUser: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.MANAGE_USERS}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['ManageUsers'],
        }),
        getUserDetail: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.MANAGE_USERS}/${id}`,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['ManageUsers'],
        }),
        updateUser: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.MANAGE_USERS}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['ManageUsers'],
        }),
        getUserCars: builder.query({
            query: ({ id, page = 1, limit = 10, search = '' }) => ({
                url: `${ENDPOINTS.MANAGE_USERS}/getCarList/${id}`,
                method: 'GET',
                params: { page, limit, search },
                headers: {
                    'x-portal': 'admin',
                    'role': '3'
                }
            }),
            providesTags: ['ManageUsers', 'Vehicles'],
        }),
        exportUsers: builder.mutation({
            query: () => ({
                url: ENDPOINTS.EXPORT_USERS,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetUsersQuery,
    useDeleteUserMutation,
    useGetUserDetailQuery,
    useUpdateUserMutation,
    useGetUserCarsQuery,
    useExportUsersMutation
} = featuresApiWithUsers;

const featuresApiWithAccessories = featuresApi.injectEndpoints({
    endpoints: (builder) => ({
        getCarAccessories: builder.query({
            query: ({ search, page, limit = 10, type }) => ({
                url: ENDPOINTS.ACCESSORIES,
                method: 'GET',
                params: { search, page, limit, type },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Accessories'],
        }),
        addCarAccessory: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.ACCESSORIES,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Accessories'],
        }),
        updateCarAccessory: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.ACCESSORIES}/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Accessories'],
        }),
        deleteCarAccessory: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.ACCESSORIES}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Accessories'],
        }),
        getCarAccessoryDetails: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.ACCESSORIES}/${id}`,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Accessories'],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetCarAccessoriesQuery,
    useAddCarAccessoryMutation,
    useUpdateCarAccessoryMutation,
    useDeleteCarAccessoryMutation,
    useGetCarAccessoryDetailsQuery
} = featuresApiWithAccessories;

const dashboardApi = featuresApi.injectEndpoints({
    endpoints: (builder) => ({
        getDashboardAnalytics: builder.query<DashboardResponse, void>({
            query: () => ({
                url: ENDPOINTS.DASHBOARD,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
        }),
        getDashboardGraph: builder.query<DashboardGraphResponse, { period: string, graphType?: string }>({
            query: ({ period, graphType }) => ({
                url: ENDPOINTS.DASHBOARD_GRAPH,
                method: 'GET',
                params: { period, graphType },
                headers: {
                    'x-portal': 'admin'
                }
            }),
        }),
    }),
    overrideExisting: false,
});

const permissionsApi = featuresApi.injectEndpoints({
  endpoints: (builder) => ({
    getPermissions: builder.query({
      query: ({ search, page, limit = 10 }) => ({
        url: ENDPOINTS.PERMISSIONS,
        method: 'GET',
        params: { search, page, limit },
        headers: {
          'x-portal': 'admin'
        }
      }),
      providesTags: ['Permissions'],
    }),
    deletePermission: builder.mutation({
      query: (id) => ({
        url: `${ENDPOINTS.PERMISSIONS}${id}`,
        method: 'DELETE',
        headers: {
          'x-portal': 'admin'
        }
      }),
      invalidatesTags: ['Permissions'],
    }),
    getPermissionDetail: builder.query({
      query: (id) => ({
        url: `${ENDPOINTS.PERMISSIONS}${id}`,
        method: 'GET',
        headers: {
          'x-portal': 'admin'
        }
      }),
      providesTags: ['Permissions'],
    }),
    updatePermissionStatus: builder.mutation({
      query: ({ id, isBlocked }) => ({
        url: `${ENDPOINTS.PERMISSIONS}/updateStatus/${id}`,
        method: 'PATCH',
        body: { isBlocked },
        headers: {
          'x-portal': 'admin'
        }
      }),
      invalidatesTags: ['Permissions'],
    }),
    addPermission: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.PERMISSIONS}/add`,
        method: 'POST',
        body: data,
        headers: {
          'x-portal': 'admin'
        }
      }),
      invalidatesTags: ['Permissions'],
    }),
    updatePermission: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${ENDPOINTS.PERMISSIONS}${id}`,
        method: 'PUT',
        body: data,
        headers: {
          'x-portal': 'admin'
        }
      }),
      invalidatesTags: ['Permissions'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPermissionsQuery,
  useDeletePermissionMutation,
  useUpdatePermissionStatusMutation,
  useAddPermissionMutation,
  useGetPermissionDetailQuery,
  useUpdatePermissionMutation,
} = permissionsApi;

export const {
    useGetDashboardAnalyticsQuery,
    useGetDashboardGraphQuery
} = dashboardApi;

const subAdminApi = featuresApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubAdmins: builder.query({
      query: ({ search, limit = 10, page = 1 }) => ({
        url: `${ENDPOINTS.SUB_ADMIN}/`,
        method: "GET",
        params: { search, limit, page },
        headers: {
          "x-portal": "admin",
        },
      }),
      providesTags: ["SubAdmin"],
    }),
    addSubAdmin: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.SUB_ADMIN}/add`,
        method: "POST",
        body: data,
        headers: {
          "x-portal": "admin",
        },
      }),
      invalidatesTags: ["SubAdmin"],
    }),
    updateSubAdminStatus: builder.mutation({
      query: ({ id, isBlocked }) => ({
        url: `${ENDPOINTS.SUB_ADMIN}/${id}`,
        method: "PUT",
        body: { isBlocked },
        headers: {
          "x-portal": "admin",
        },
      }),
      invalidatesTags: ["SubAdmin"],
    }),
    deleteSubAdmin: builder.mutation({
      query: (id) => ({
        url: `${ENDPOINTS.SUB_ADMIN}/${id}`,
        method: "DELETE",
        headers: {
          "x-portal": "admin",
        },
      }),
      invalidatesTags: ["SubAdmin"],
    }),
    getSubAdminById: builder.query({
      query: (id) => ({
        url: `${ENDPOINTS.SUB_ADMIN}/${id}`,
        method: "GET",
        headers: {
          "x-portal": "admin",
        },
      }),
      providesTags: ["SubAdmin"],
    }),
    updateSubAdmin: builder.mutation({
      query: ({ id, data }) => ({
        url: `${ENDPOINTS.SUB_ADMIN}/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "x-portal": "admin",
        },
      }),
      invalidatesTags: ["SubAdmin"],
    }),
  }),
  overrideExisting: false,
});

export const { useAddSubAdminMutation, useGetSubAdminsQuery, useUpdateSubAdminStatusMutation, useDeleteSubAdminMutation, useGetSubAdminByIdQuery, useUpdateSubAdminMutation } = subAdminApi;

// Revenue API
export const revenueApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getRevenueList: builder.query({
      query: ({ search = "", page = 1, limit = 10 }) => ({
        url: `${ENDPOINTS.REVENUE}list`,
        method: "GET",
        params: { search, page, limit },
        headers: {
          "x-portal": "admin",
        },
      }),
      providesTags: ["Revenue"],
    }),
    getRevenueGraph: builder.query<RevenueGraphResponse, { period: string }>({
      query: ({ period }) => ({
        url: `${ENDPOINTS.REVENUE}graph`,
        method: "GET",
        params: { period },
        headers: {
          "x-portal": "admin",
        },
      }),
      providesTags: ["Revenue"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetRevenueListQuery, useGetRevenueGraphQuery } = revenueApi;

// Notification API
export const notificationApi = api.injectEndpoints({
    endpoints: (builder) => ({
        sendNotification: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.SEND_NOTIFICATION,
                method: 'POST',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Notifications'],
        }),
        getNotifications: builder.query({
            query: ({ search, page, limit = 10, type, recipientType }) => ({
                url: ENDPOINTS.NOTIFICATIONS,
                method: 'GET',
                params: { search, page, limit, type, recipientType },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Notifications'],
        }),
        getNotificationById: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.NOTIFICATIONS}/${id}`,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Notifications'],
        }),
        deleteNotification: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.NOTIFICATIONS}/${id}`,
                method: 'DELETE',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Notifications'],
        }),
    }),
    overrideExisting: false,
});

export const { useSendNotificationMutation, useGetNotificationsQuery, useDeleteNotificationMutation, useGetNotificationByIdQuery } = notificationApi;

// Showroom API
export const showroomApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getShowrooms: builder.query<any, any>({
            query: (params) => ({
                url: ENDPOINTS.SHOWROOMS,
                method: "GET",
                params: {
                    search: params?.search || "",
                    page: params?.page || 1,
                    limit: params?.limit || 10
                },
                headers: {
                    "x-portal": "admin",
                },
            }),
            providesTags: ["Showrooms"],
        }),
    }),
    overrideExisting: false,
});

export const { useGetShowroomsQuery } = showroomApi;
